<template>
  <section v-bind:id="menuItem.anchor" class="latest-posts">
    <div class="container">
      <!-- Section title 
      <div class="section-title mb-60">
        <h2 class="light dark mb-30">{{menuItem.name}} <span class="bold">{{menuItem.nameBold}}</span></h2>
        <p class="light opas dark"></p>
      </div>
      -->
      <div class="row">
        <div class="col-lg-1">&nbsp;</div>

        <div v-for="(card) in cards" class="col-12 mb-30" :key="card.name">
          <div class="blog-card" v-bind:id="card.anchorName">
            <div class="blog-text">
              <!-- Title -->
              <h3 class="dark bold mb-15" style="word-break:normal;">{{card.title}}</h3>
              <!-- Text -->
              <div class="dark light opas mb-30" v-html="card.text"></div>
              <a href="#" data-toggle="modal" data-target=".wideCardDetailModal" v-on:click="setModalContent(card, false)"
                 class="button button-2 mr-1">{{card.button1Text}}<i class="fas fa-chevron-right"></i></a>
              <a href="#" data-toggle="modal" data-target=".wideCardDetailModal" v-on:click="setModalContent(card, true)"
                 class="button button-2">{{card.button2Text}}<i class="fas fa-chevron-right"></i></a>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="modal fade wideCardDetailModal" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalTitle" v-if="!modal.showAlternative" >{{modal.title}}</h5>
            <h5 class="modal-title" id="modalTitle" v-else >{{modal.alternativeTitle}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" v-if="!modal.showAlternative">
            <div class="px-4 py-2" v-html="modal.detailText" />
          </div>
          <div class="modal-body" v-else>
            <div class="px-4 py-2" v-html="modal.alternativeDetailText" />
          </div>
          <div class="modal-footer">
            <button v-if="!modal.showAlternative" v-on:click="toggleModalViewAndScroll" type="button" class="button button-2">{{modal.alternativeTitle}} <i class="fas fa-chevron-right"></i></button>
            <button v-if="modal.showAlternative" v-on:click="toggleModalViewAndScroll" type="button" class="button button-2">{{modal.title}} <i class="fas fa-chevron-right"></i></button>
          </div>
        </div>
      </div>
    </div>

  </section>
</template>

<script>
  export default {
    components: {
    },
    data () {
      return {
        cards: [],
        modal: {
          title: 'test',
          detailText: 'details',
          alternativeTitle: 'price',
          alternativeDetailText: '',
          showAlternative: false
        }
      }
    },
    props: ['menuItem'],
    computed: {
      baseUrl () {
        return this.$store.getters.baseUrl()
      }
    },
    mounted () {
      console.log('mounted WideCards')

      $('.button-3').on('click', function () {
        // Animate
        $('html, body').stop().animate({
          scrollTop: $($(this).attr('data-anchor')).offset().top - 90
        }, 1000)
        return false
      })

      this.$http.get(this.$store.getters.serviceClient().getCollectionUrl(this.$props.menuItem.collection))
        .then((response) => {
          if (response.ok) {
            console.log(response.body.entries)
            this.$data.cards = response.body.entries
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    methods: {
      setModalContent (card, showAlternative) {
        this.$data.modal.detailText = card.button1Content
        this.$data.modal.title = card.button1Text
        this.$data.modal.alternativeTitle = card.button2Text
        this.$data.modal.alternativeDetailText = card.button2Content
        this.$data.modal.showAlternative = showAlternative
      },
      toggleModalViewAndScroll () {
        $('.modal').stop().animate({
          scrollTop: 20
        }, 500)
        this.modal.showAlternative = !this.modal.showAlternative
      }
    }
  }
</script>

<style scoped="scoped">
  @media screen and (max-width: 768px) {
    .modal-footer{
      margin-bottom: 5em;
    }  
  }
</style>



// WEBPACK FOOTER //
// src/components/sections/WideCards.vue